/**
 * Billing: contact-based plans (V46). Prices and caps are NOT here; they come
 * from the server plan catalog and are interpolated into these strings.
 */
export const enBilling = {
  'billing.pageTitle': 'Billing',
  'billing.pageSubtitle': 'Plan, payments, and credits for this workspace.',

  'billing.plans.title': 'Plans',
  'billing.plans.perMonth': '/mo',
  'billing.plans.customPrice': 'Custom',
  'billing.plans.current': 'Current plan',
  'billing.plans.recommended': 'Fits your contacts',
  'billing.plans.upgrade': 'Upgrade to {name}',
  'billing.plans.switch': 'Switch to {name}',
  'billing.plans.contactUs': 'Talk to us',
  'billing.plans.redirecting': 'Redirecting…',
  'billing.plans.loadError': 'Plans could not be loaded. Refresh the page to try again.',
  'billing.plans.addOnsTitle': 'Add-ons',
  'billing.plans.comingSoon': 'Coming soon',
  'billing.plans.addOnPrice': '${price}/{unit}',
  'billing.plans.unit.seat': 'seat',
  'billing.plans.unit.month': 'mo',
  'billing.plans.contactDefinition': 'A contact is a customer you can reach: an email subscriber, or someone with WhatsApp, Instagram or Messenger. Customers you cannot message do not count.',
  'billing.plans.feature.contacts': 'Up to {count} contacts',
  'billing.plans.feature.customContacts': 'Custom contact volume',
  'billing.plans.feature.allChannels': 'Email, WhatsApp, Instagram and Messenger',
  'billing.plans.feature.oneChannel': 'Email plus one channel',
  'billing.plans.feature.unlimitedFlows': 'Unlimited flows',
  'billing.plans.feature.flows': '{count} active flows',
  'billing.plans.feature.inboxSeat': '1 Inbox seat',
  'billing.plans.feature.inboxSeats': '{count} Inbox seats',
  'billing.contacts.title': 'Contacts',
  'billing.contacts.ofCap': '/ {cap}',
  'billing.contacts.nextTier': 'Next: {name}, up to {cap} contacts for ${price}/mo',
  'billing.contacts.customNext': 'For a larger contact volume, talk to us about a custom plan.',
  'billing.contacts.warning': 'You have used {pct}% of your contacts. Marketing messages to new contacts will pause when you pass {cap}.',
  'billing.contacts.over': 'Over your plan: marketing messages to contacts added after the first {cap} are paused. Nothing is deleted.',
  'billing.banner.warning': 'You have used {pct}% of your {cap} contacts.',
  'billing.banner.over': 'You have {count} contacts on a {cap}-contact plan. Marketing to the newest contacts is paused.',
  'billing.banner.upgrade': 'Upgrade',
  'billing.overview.currentPlan': 'Current Plan',
  'billing.overview.nextBilling': 'Next billing: {date}',
  'billing.overview.planManagement': 'Plan management',
  'billing.overview.nativeNotice': 'Plan changes aren’t available in the app.',
  'billing.payment.welcome': 'Welcome to {name}!',
  'billing.payment.success': 'Your upgrade was successful',
  'billing.payment.contactsIncluded': 'Up to {count} contacts included',
  'billing.payment.error': 'The payment page could not be opened. Please try again.',
} as const;
